import { noop } from 'lodash/fp';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DAKTELA_CHAT } from 'utils/externalScripts';

import { useAnalyticsEvent } from '@skippay/core/components/GoogleAnalytics';
import useUserCountryRelatedInfo from '@skippay/core/hooks/useUserCountryRelatedInfo';
import { isInPopUpBrowser } from '@skippay/core/modules/clientInfo';
import { loadScript } from '@skippay/core/modules/externalScripts';

const PAGE_TYPE_SELF_CARE = 'self-care';
const PAGE_TYPE_WEB = 'web';

export const pageTypePropsConfig = {
	// Self-care and /prihlaseni chat after 10 seconds
	[PAGE_TYPE_SELF_CARE]: { timeout: 10000 },
	// All page except /prihlaseni, chat after 5 seconds
	[PAGE_TYPE_WEB]: { timeout: 5000 },
};

// Use module scope mutable variable, once the DaktelaCustomerChat is initialized it holds for the whole runtime
// existence. The DaktelaCustomerChat component is just React API for dirty delayed DOM mutation.
let initialized = false;

interface Props {
	pageType?: 'self-care' | 'web';
}

function DaktelaCustomerChat(props: Props) {
	const dispatch = useDispatch();
	const sendAnalyticsEvent = useAnalyticsEvent();

	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (!initialized) {
			const timeoutFallback = 5000;
			const timeout = props.pageType
				? pageTypePropsConfig[props.pageType].timeout || timeoutFallback
				: timeoutFallback;

			const timerId = setTimeout(() => {
				initialized = true;

				// @ts-expect-error - loadScript is not typed
				dispatch(loadScript(DAKTELA_CHAT)).then(() => {
					sendAnalyticsEvent({
						eCat: 'External Plugins',
						eAct: 'Daktela Chat',
						eLab: 'Web chat loaded',
					});
				}, noop);
			}, timeout);
			return () => window.clearTimeout(timerId);
		}
	}, []);

	return null;
}

function DaketelaCustomeChatWrapper(props: Props) {
	const { country } = useUserCountryRelatedInfo();

	if (isInPopUpBrowser() || initialized || country !== 'CZ') {
		return null;
	}

	const MemoComponent = React.memo(DaktelaCustomerChat);

	return <MemoComponent {...props} />;
}

export default process.env.NODE_ENV !== 'development' &&
typeof window !== 'undefined' &&
!process.env.MOB_APP_BUILD
	? DaketelaCustomeChatWrapper
	: () => null;
